'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Context from "@prisma-cms/context";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Table = require('apollo-cms/lib/DataView/List/Table');

var _filters = require('@prisma-cms/filters');

var _filters2 = _interopRequireDefault(_filters);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimersView = (_temp = _class = function (_TableView) {
  _inherits(TimersView, _TableView);

  function TimersView() {
    _classCallCheck(this, TimersView);

    return _possibleConstructorReturn(this, _TableView.apply(this, arguments));
  }

  TimersView.prototype.componentWillMount = function componentWillMount() {
    this.state.columnData = this.initColumns();
    _TableView.prototype.componentWillMount && _TableView.prototype.componentWillMount.call(this);
  };

  TimersView.prototype.renderDate = function renderDate(date) {
    return date ? _react2.default.createElement('span', {
      style: {
        whiteSpace: "nowrap"
      }
    }, (0, _moment2.default)(date).format("DD.MM.YYYY HH:mm:ss")) : null;
  };

  TimersView.prototype.initColumns = function initColumns() {
    var _this2 = this;

    var _context = this.context,
        ProjectLink = _context.ProjectLink,
        UserLink = _context.UserLink,
        TaskLink = _context.TaskLink,
        TaskStatus = _context.TaskStatus;
    return [{
      id: "Project",
      label: "Проект",
      hidden: false,
      renderer: function renderer(value, record) {
        var _ref = record && record.Task || {},
            Project = _ref.Project;

        return Project ? _react2.default.createElement(ProjectLink, {
          object: Project
        }) : null;
      }
    }, {
      id: "Task",
      label: "Задача",
      hidden: false,
      renderer: function renderer(value, record) {
        // console.log(record);
        return value ? _react2.default.createElement(TaskLink, {
          object: value
        }) : null;
      }
    }, {
      id: "status",
      label: "Статус",
      hidden: false,
      renderer: function renderer(value, record) {
        var _ref2 = record && record.Task || {},
            status = _ref2.status;

        return status ? _react2.default.createElement(TaskStatus, {
          value: status
        }) : null;
      }
    }, {
      id: "TaskCreatedAt",
      label: "Дата постановки задачи",
      hidden: true,
      renderer: function renderer(value, record) {
        var _ref3 = record || {},
            Task = _ref3.Task;

        var _ref4 = Task || {},
            createdAt = _ref4.createdAt;

        return _this2.renderDate(createdAt);
      }
    }, {
      id: "createdAt",
      label: "Начало",
      hidden: false,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "stopedAt",
      label: "Конец",
      hidden: false,
      renderer: function renderer(value, record) {
        return _this2.renderDate(value);
      }
    }, {
      id: "duration",
      label: "Длительность",
      hidden: false,
      renderer: function renderer(value, record) {
        var output = null;

        var _ref5 = record || {},
            createdAt = _ref5.createdAt,
            stopedAt = _ref5.stopedAt;

        if (createdAt && stopedAt) {
          var start = (0, _moment2.default)(createdAt);
          var end = (0, _moment2.default)(stopedAt);
          var diff = end.diff(start);
          output = _moment2.default.utc(diff).format("HH:mm:ss");
        }

        return output;
      }
    }, {
      id: "CreatedBy",
      label: "Исполнитель",
      hidden: false,
      renderer: function renderer(value, record) {
        return value ? _react2.default.createElement(UserLink, {
          user: value,
          size: 'small'
        }) : null;
      }
    }, {
      id: "Author",
      label: "Постановщик задачи",
      hidden: true,
      renderer: function renderer(value, record) {
        var _ref6 = record || {},
            Task = _ref6.Task;

        var _ref7 = Task || {},
            CreatedBy = _ref7.CreatedBy;

        return CreatedBy ? _react2.default.createElement(UserLink, {
          user: CreatedBy,
          size: 'small'
        }) : null;
      }
    }, {
      id: "RelatedTo",
      label: "Связано с",
      hidden: true,
      renderer: function renderer(value, record) {
        console.log("status", TaskLink); // return value ? <TaskStatus
        //   value={value}
        // /> : null;

        return value && value.length ? value.map(function (n) {
          return _react2.default.createElement(TaskLink, {
            key: n.id,
            object: n
          });
        }).reduce(function (a, b) {
          return [a, ", ", b];
        }) : null;
      }
    }];
  };

  TimersView.prototype.getColumns = function getColumns() {
    return this.state.columnData;
  };

  TimersView.prototype.renderFilters = function renderFilters() {
    var _props = this.props,
        filters = _props.filters,
        setFilters = _props.setFilters;
    return filters && setFilters ? _react2.default.createElement(_filters2.default, {
      queryName: 'timers',
      filters: filters,
      setFilters: setFilters
    }) : null;
  };

  TimersView.prototype.render = function render() {
    var _context2 = this.context,
        Pagination = _context2.Pagination,
        Grid = _context2.Grid;
    var _props2 = this.props,
        page = _props2.page,
        showAll = _props2.showAll,
        setShowAll = _props2.setShowAll,
        filters = _props2.filters;
    var _props$data = this.props.data,
        objectsConnection = _props$data.objectsConnection,
        loading = _props$data.loading,
        limit = _props$data.variables.first;

    var _ref8 = objectsConnection || {},
        edges = _ref8.edges,
        aggregate = _ref8.aggregate;

    var _ref9 = aggregate || {},
        _ref9$count = _ref9.count,
        count = _ref9$count === undefined ? 0 : _ref9$count;

    var showAllButton = void 0;

    if (showAll) {
      showAllButton = _react2.default.createElement(_materialUi.Button, {
        onClick: function onClick(event) {
          return setShowAll(false);
        }
      }, "\u0421\u043A\u0440\u044B\u0442\u044C");
    } else if (limit && count && count > limit && setShowAll) {
      showAllButton = _react2.default.createElement(_materialUi.Button, {
        onClick: function onClick(event) {
          return setShowAll(true);
        }
      }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435 (", count, ')');
    }

    var content = _react2.default.createElement(_react.Fragment, null, _TableView.prototype.render.call(this), _react2.default.createElement('div', {
      style: {
        textAlign: "center"
      }
    }, _react2.default.createElement(Grid, {
      container: true,
      style: {
        display: "inline-flex",
        alignItems: "center",
        width: "auto"
      }
    }, _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(Pagination, {
      limit: limit,
      total: count,
      page: page || 1,
      style: {
        marginTop: 20
      }
    })), _react2.default.createElement(Grid, {
      item: true
    }, showAllButton))));

    return content;
  };

  return TimersView;
}(_Table.TableView), _class.propTypes = _extends({}, _Table.TableView.propTypes, {
  filters: _propTypes2.default.object,
  setFilters: _propTypes2.default.func
}), _class.defaultProps = _extends({}, _Table.TableView.defaultProps, {
  title: ""
}), _temp);
exports.default = (0, _materialUi.withStyles)(_Table.styles)(function (props) {
  return _react2.default.createElement(TimersView, props);
});
module.exports = exports['default'];